// src/layout/MainLayout.js
import {
  Button,
  Layout,
  Input,
  Row,
  Col,
  List,
  Divider,
  Flex,
  Space,
} from "antd";
import {
  cloverbayLogo,
  getInTouch,
  linkedinLogo,
  socailmediaicons,
} from "../assets";
import {
  DoubleRightOutlined,
  LinkedinFilled,
  LinkedinOutlined,
  LinkOutlined,
  MailOutlined,
  MenuOutlined,
  PhoneOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";

const { Header, Content, Footer } = Layout;

const { Search } = Input;

const MainLayout = ({ children }) => {
  const navigate = useNavigate();

  const handleSubmitFooterQueryEmail = (value) => {
    const email = encodeURIComponent(value.trim());
    if (!email) return;

    window.open(`/contact-us?email=${email}`, '_blank'); // open in new tab
  };


  return (
    <Layout>
      <Header className="header">
        <div className="marquee-wrapper">
          {/* <div className="marquee">
            <p>An ISO 27001 -2022 Certified Company</p>
          </div> */}
          <Marquee style={{height:"auto",weight:"100%"}}><p style={{fontWeight:"500",fontSize:"14px"}}>An ISO 27001 -2022 Certified Company</p></Marquee>
        </div>
        <div className="header-1">
          <div style={{ width: "100%" }}>
            <Flex
              justify={"space-between"}
              align="center"
              style={{ marginRight: "15px", marginLeft: "26px" }}
              gap={20}
            >
              <div className="header-contact-dev" style={{ flexShrink: 0 }}>
                <div className="header-2-text">
                  <PhoneOutlined style={{ color: "#635AD9" }} />
                  &nbsp; +91-9148690051
                </div>

                <div className="header-2-text hide-on-mobile">
                  <MailOutlined style={{ color: "#635AD9" }} />
                  &nbsp; contactus@cloverbaytechnologies.com
                </div>
              </div>

              <div style={{ flexShrink: 0 }}>
                {/* <img
                  src={socailmediaicons}
                  alt="social media icons"
                  style={{ cursor: "pointer" }}
                  className="hide-on-mobile"
                /> */}
                <Button
                  type="link"
                  icon={<LinkedinOutlined />}
                  href="https://www.linkedin.com/company/clover-bay-technologies-pvt-ltd/"
                  target="_blank"
                  size="large"
                  style={{ color: "#635AD9", fontSize: "20px" }}
                />
              </div>
            </Flex>
          </div>
        </div>
        <div className="header-2">
          <img
            src={cloverbayLogo}
            alt="cloverbay technologies"
            className="header-logo"
            onClick={() => navigate("/")}
          />
          {/* <Row style={{ alignItems: "center" }} className="hide-on-mobile">
            <div className="header-menu-title">Capabilities</div>
            <div className="header-menu-title">Industries</div>
            <div className="header-menu-title">Insights</div>
            <div className="header-menu-title">Careers</div>
            <div className="header-menu-title">About Us</div>
            <Button className="explore-btn" shape="round" size="large">
              TALK TO US
            </Button>
          </Row> */}
          {/* <MenuOutlined className="mobile-view-only" size={"32px"} /> */}
        </div>
      </Header>
      <Content style={{ minHeight: "80vh" }}>{children}</Content>
      <Footer className="footer">
        <div
          className="mail-footer"
          data-aos="flip-down"
          data-aos-duration="700"
          data-aos-delay="100"
        >
          <Row align={"center"}>
            <Col md={5}>
              {" "}
              <img src={getInTouch} alt="get in touch" className="mail-img" />
            </Col>
            <Col md={9}>
              <Search
                placeholder="Enter Email Address"
                enterButton={<ShareAltOutlined color="white" />}
                size="large"
                style={{ marginTop: "8px" }}
                onSearch={handleSubmitFooterQueryEmail}
              />
            </Col>
          </Row>
        </div>
        <Row
          style={{ marginTop: "75px" }}
          className="mobile-padding"
          justify={"center"}
          // justify={"space-between"}
          gutter={10}
        >
          <Col md={6}>
            <div className="footer-heading">About Us</div>
            <Row>
              <Col md={9} sm={9}>
                <Divider
                  style={{
                    marginTop: "20px",
                    marginBottom: "30px",
                    borderColor: "#219BE4",
                  }}
                />
              </Col>
              <Col md={12} sm={12}>
                <Divider
                  style={{
                    marginTop: "20px",
                    marginBottom: "30px",
                    borderColor: "#ffffff",
                  }}
                />
              </Col>
            </Row>

            <div className="card-content-text footer-sub-text">
              Clover Bay provides technology and product consulting services
              with special focus on eCommerce, Retail Digital & Technology
              transformation, and Digital Experience.
            </div>

            <Button
              size="large"
              shape="round"
              className="explore-btn mb-30 mt-30"
              onClick={(e) => {
                e.preventDefault();
                window.open("/contact-us", "_blank");
              }}
            >
              CONTACT US
            </Button>
            <Row className="mb-30" align={"middle"}>
              <div className="card-content-text footer-socail-media-text">
                - Follow on
              </div>

              <Button
                type="link"
                icon={<LinkedinOutlined />}
                href="https://www.linkedin.com/company/clover-bay-technologies-pvt-ltd/"
                target="_blank"
                size="large"
                style={{
                  color: "#635AD9",
                  fontSize: "30px", // increase text & icon size
                }}
              />
            </Row>
          </Col>
          {/* <Col md={6}>
            <div className="footer-heading">Quick Link</div>
            <Row>
              <Col md={9}>
                <Divider
                  style={{
                    marginTop: "20px",
                    marginBottom: "30px",
                    borderColor: "#219BE4",
                  }}
                />
              </Col>
              <Col md={12}>
                <Divider
                  style={{
                    marginTop: "20px",
                    marginBottom: "30px",
                    borderColor: "#ffffff",
                  }}
                />
              </Col>
            </Row>
            <div className="card-content-text footer-sub-text">
              <DoubleRightOutlined /> About
            </div>
            <div className="card-content-text footer-sub-text">
              <DoubleRightOutlined /> Contact Us
            </div>
            <div className="card-content-text footer-sub-text">
              <DoubleRightOutlined /> Blog & News
            </div>
          </Col> */}
          {/* <Col md={6}>
            <div className="footer-heading">Our Capabilities</div>
            <Row>
              <Col md={9}>
                <Divider
                  style={{
                    marginTop: "20px",
                    marginBottom: "30px",
                    borderColor: "#219BE4",
                  }}
                />
              </Col>
              <Col md={12}>
                <Divider
                  style={{
                    marginTop: "20px",
                    marginBottom: "30px",
                    borderColor: "#ffffff",
                  }}
                />
              </Col>
            </Row>
    
            <div className="card-content-text footer-sub-text">
              <DoubleRightOutlined /> Domain Expertise{" "}
            </div>
            <div className="card-content-text footer-sub-text">
              <DoubleRightOutlined /> Technology Excellence{" "}
            </div>
            <div className="card-content-text footer-sub-text">
              <DoubleRightOutlined /> Rapid Accelerators{" "}
            </div>
            <div className="card-content-text footer-sub-text">
              <DoubleRightOutlined /> Proven Results{" "}
            </div>
          </Col> */}
          <Col md={6}>
            <div className="footer-heading">Contact Us</div>
            <Row>
              <Col md={9}>
                <Divider
                  style={{
                    marginTop: "20px",
                    marginBottom: "30px",
                    borderColor: "#219BE4",
                  }}
                />
              </Col>
              <Col md={12}>
                <Divider
                  style={{
                    marginTop: "20px",
                    marginBottom: "30px",
                    borderColor: "#ffffff",
                  }}
                />
              </Col>
            </Row>
            {/* <List
            size="small"
            dataSource={[
              "First Floor # 1612, 7th Cross, 19th Main, Sector-1, HSR Layout, Bengaluru, Karnataka, India - 560102",
              "+91-9148690051",
              "www.cloverbaytechnologies.com",
            ]}
            renderItem={(item) => (
              <List.Item className="card-content-text footer-sub-text">
                {item}
              </List.Item>
            )}
          /> */}
            <div className="card-content-text footer-sub-text">
              First Floor # 1612, 7th Cross, 19th Main, Sector-1, HSR Layout,
              Bengaluru, Karnataka, India - 560102{" "}
            </div>
            <div className="card-content-text footer-sub-text">
              <PhoneOutlined /> +91-9148690051
            </div>
            <div className="card-content-text footer-sub-text">
              <MailOutlined /> contactus@cloverbaytechnologies.com
            </div>
            <div className="card-content-text footer-sub-text">
              www.cloverbaytechnologies.com
            </div>
          </Col>
        </Row>
        <Divider
          style={{
            marginTop: "30px",
            marginBottom: "30px",
            borderColor: "#ffffff",
          }}
        />
        <Row justify={"space-between"}>
          <div className="member-card-designation" style={{ color: "#D9D9D9" }}>
            copyright © 2025 Clover Bay Technologies. All right reserved.
          </div>
          <div className="center-policies">
            <Row>
              <Link
                to={"/terms-and-conditions"}
                className="member-card-designation footer-sub-text"
                style={{ color: "#D9D9D9", marginRight: "10px" }}
                onClick={(e) => {
                  e.preventDefault(); // Prevents default SPA navigation
                  window.open("/terms-and-conditions", "_blank");
                }}
              >
                Terms & Conditions{" "}
              </Link>
              <Link
                to="/privacy-policy"
                className="member-card-designation footer-sub-text"
                style={{ color: "#D9D9D9" }}
                onClick={(e) => {
                  e.preventDefault();
                  window.open("/privacy-policy", "_blank");
                }}
              >
                Privacy Policy
              </Link>
            </Row>
          </div>
        </Row>
      </Footer>
    </Layout>
  );
};

export default MainLayout;
